import { render, staticRenderFns } from "./UserPrimaryColor.vue?vue&type=template&id=63a1b57c&scoped=true"
import script from "./UserPrimaryColor.vue?vue&type=script&lang=ts"
export * from "./UserPrimaryColor.vue?vue&type=script&lang=ts"
import style0 from "./UserPrimaryColor.vue?vue&type=style&index=0&id=63a1b57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1b57c",
  null
  
)

export default component.exports